import React, { useState } from "react";
import ReactFlow, { Controls, Node, Edge } from "reactflow";
import "reactflow/dist/style.css";

import { nodeTypes } from "./DiscipleshipPathwayFlow/Nodes/nodeTypes";
import { edgeTypes } from "components/Flow/Edges/edgeTypes";
import useUpdatedLocalNodeValues from "components/Flow/Nodes/useUpdatedLocalNodeValues";
import useUpdatedLocalEdgeValues from "components/Flow/Edges/useUpdatedLocalEdgeValues";

import {
  onNodeClickHandler,
  onPaneClickHandler,
} from "components/Flow/Nodes/nodeHandlers";

import StandardBackground from "components/Flow/StandardBackground";


interface DiscipleshipPathwayFlowProps {
  nodes: Node[];
  edges: Edge[];
  onNodeSelect: (node: Node | null) => void;
}

const DiscipleshipPathwayFlow: React.FC<DiscipleshipPathwayFlowProps> = ({
  nodes,
  edges,
  onNodeSelect,
}) => {
  const [selectedNode, setSelectedNode] = useState<Node | null>(null);
  const updatedNodes = useUpdatedLocalNodeValues(nodes, { selectedNodeId: selectedNode?.id, update: { type: "discipleshipPathwayNode" } });
  const updatedEdges = useUpdatedLocalEdgeValues(edges, { update: { type: "standardEdge" } });
  

  return (
    <div style={{ height: "80vh", width: "100%", position: "relative" }}>
      <ReactFlow
        nodes={updatedNodes}
        edges={updatedEdges}
        nodeTypes={nodeTypes}
        edgeTypes={edgeTypes}
        onNodeClick={(_e, node) => {
                  setSelectedNode(node);
                  onNodeClickHandler(node, onNodeSelect);
                }}
        onPaneClick={() => {
                  setSelectedNode(null);
                  onNodeSelect(null);
                  onPaneClickHandler(onNodeSelect);
                }}
        fitView
        snapToGrid
        snapGrid={[20, 20]}
        minZoom={0.1}
        maxZoom={4}
      >
        <Controls />
        <StandardBackground />
      </ReactFlow>
    </div>
  );
};

export default DiscipleshipPathwayFlow;
